import { IconBase, type IconProps } from '@doxyme/icons';

import type { JSX } from 'react';

export const TextareaResize = (props: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...props}>
    {Boolean(props) && props.type === 'stroke' ? (
      <>
        <path
          d='M0.9375 11L10.9375 1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5.9375 11L10.9375 6'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <path
          d='M0.9375 11L10.9375 1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5.9375 11L10.9375 6'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    )}
  </IconBase>
);
